import { render } from "./SearchAnnouncementItem.vue?vue&type=template&id=5627e9f1"
import script from "./SearchAnnouncementItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchAnnouncementItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchAnnouncementItem.vue?vue&type=style&index=0&id=5627e9f1&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__